import { useState } from 'react';
import { formSessionQuery, useAxiosInstance, usePoMutation } from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';

interface Variables {
	paramsString: string;
	rezaCode?: string;
	nazev?: string;
}

export const useFormSession = () => {
	const [redirectUrl, setRedirectUrl] = useState<Nullable<string>>(null);
	const { axiosInstance } = useAxiosInstance();

	const submitMutation = usePoMutation({
		mutationFn: async ({ rezaCode, paramsString, nazev }: Variables) => {
			const params = Object.fromEntries(new URLSearchParams(paramsString));

			return formSessionQuery(
				axiosInstance,
				params.typ,
				params.formId,
				rezaCode,
				nazev
			);
		},
		onMutate: () => setRedirectUrl(null),
		onSuccess: (data) => {
			if (data?.redirectUrl) {
				setRedirectUrl(data.redirectUrl);
				window.location.href = data.redirectUrl;
			}
		},
	});

	return {
		submit: submitMutation.mutate,
		isLoading: submitMutation.isLoading,
		isSuccess: submitMutation.isSuccess,
		redirectUrl,
	};
};
